import * as d3 from 'd3';
import Holidays from 'date-holidays';

export const dayMs = 1000 * 60 * 60 * 24;
export const buffer = 5;
export const printHeaderHeight = 40
export const rowHeight = 36;

export function getWidthPerDay(isprintView) {
   return isprintView ? 22 : 60;
}

export function getRowHeight(isprintView) {
   return isprintView ? 36 : 36;
}


export const germanDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

export function snap(val, isprintView) {
  let widthPerDay = getWidthPerDay(isprintView)
	return Math.round(val / widthPerDay) * widthPerDay
}

export function nDaysLater(date, n) {
  const result = new Date(date);
  result.setDate(result.getDate() + n);
  return result;
}

export function nextDay(date) {
  return nDaysLater(date, 1);
}

export function isLastDayOfMonth(date) {
  return nextDay(date).getDate() === 1;
}

export function isWeekstart(date) {
  return date.getDay() === 1;
}

export function isUserBooking(p, u, b) {
   return b.user_id === u.id
}

export function is_bookable(b, selectedDays) {
	if (!b.start || !b.end) {
		return false;
	}
	
	let firstDay = selectedDays[0];
	let lastDay   = selectedDays.at(-1);
	//console.log("firstDay=" + firstDay + " lastDay=" + lastDay)

	let isoFirst = formatDateYYYYMMDD(firstDay) + "T00:00:00.000Z"
	let isoLast  = formatDateYYYYMMDD(lastDay) + "T00:00:00.000Z"
	let intersects = new Date(b.end) >= new Date(isoFirst) && new Date(b.start) <= new Date(isoLast);
	//console.log("is_bookable b=" + JSON.stringify(b) + " selectedDays=" + JSON.stringify(selectedDays))
	//console.log("intersects" + intersects);
	return intersects;
}

export function isBookingInProject(p, b) {
  return is_bookable(b, [p.start, p.end]);
}

export function prepTask(pid2pnames, p, u, b) {
  let inproject = b.project_id === p.id
  let pname = pid2pnames[b.project_id.toString()]
  let label = u.short + (inproject ?  "" : ">" + pname)
  return {id: b.id,
	    start: b.start,
	    end: b.end,
		  color: p.color,
		  pname: pname,
      project_id: b.project_id,
		  inproject: inproject,
      label: label
  };
}

export function prepBooking(b) {	
  console.log("prepBooking b=" + JSON.stringify(b))	
  const startDate =  new Date(b.start + "T00:00:00Z");
  const endDate = new Date(b.end + "T00:00:00Z");
//  console.log("prepBooking startDate=" + startDate)	
//  console.log("prepBooking endDate=" + endDate)	
  return {id: b.id, start: startDate, end: endDate, oldstart: b.start, oldend: b.end, user_id: b.user_id, project_id: b.project_id }
}


export function prepProject(p) {
	const startDate =  new Date(p.start + "T00:00:00Z");
	const endDate = new Date(p.end + "T00:00:00Z");
	return {id: p.id, name: p.name, description: p.description, status: p.status,
		 start: new Date(p.start), end: endDate, color: p.color, altname: p.altname }	
}

export function getBavariaHolidaysBetween(startDate, endDate) {
  const hd = new Holidays('DE', 'BY'); // Germany, Bavaria
  const holidays = [];

  for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
    const yearHolidays = hd.getHolidays(year);
    yearHolidays.forEach(h => {
      const d = new Date(h.date);
      if (h.type === "public" && d >= startDate && d <= endDate) {
        holidays.push({ name: h.name, date: d });
      }
    });
  }

  return holidays;
}

export function createAxisLine(startDate, endDate, data, format, getEnd = null, withWeekends = false, isprintView = false) {
  const line = document.createElement("div");
  const holidays = getBavariaHolidaysBetween(startDate, endDate);
  const widthPerDay = getWidthPerDay(isprintView);

  line.className = "time-axis-line";

  data.forEach((d, i) => {
    // 1. Determine the logical start and end of THIS specific cell
    let cellStart = d;
    let cellEnd = getEnd ? getEnd(data, i) : d3.timeDay.offset(d, 1);

    // 2. CLIPPING: Ensure the cell doesn't go outside the axis boundaries
    // If the week starts before the axis, cut the start to match startDate
    const actualStart = cellStart < startDate ? startDate : cellStart;
    // If the week ends after the axis, cut the end to match endDate
    const actualEnd = cellEnd > endDate ? endDate : cellEnd;

    // 3. Calculate span only for the visible portion
    const spanMs = actualEnd - actualStart;
    const spanDays = spanMs / dayMs;

    // Skip rendering if the cell is completely outside the visible range
    if (spanDays <= 0) return;

    const cell = document.createElement("div");
    cell.className = "time-axis-cell" + (isprintView ? " printview" : "");
    
    const isWeekend = d.getDay() === 0 || d.getDay() === 6;
    const isHoliday = holidays.some(h => h.date.toDateString() === d.toDateString());

    if (withWeekends) {
      if (isWeekend) cell.classList.add("weekend");
      else if (isHoliday) cell.classList.add("holiday");
    }

    cell.style.width = `${spanDays * widthPerDay}px`;
    cell.textContent = format(d);
    line.appendChild(cell);
  });
  
  return line;
}

export function daysBetween(date1, date2) {
  const msPerDay = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  let bet = Math.floor(Math.abs(utc2 - utc1) / msPerDay);
  return bet < 7 ? bet : 7;
}


export function isHttpSuccess(xhr) {
    return xhr.status >= 200 && xhr.status < 300;
}

export function sendRequest(url, params, onSuccess, onFailure, method='POST', synch = false) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, synch); // false for synchronous

  xhr.setRequestHeader('Content-Type', 'application/json');
  var token = document.querySelector('meta[name="csrf-token"]').content;
  xhr.setRequestHeader('X-CSRF-Token', token);
  
  console.log("sendRequest params=" + JSON.stringify(params));
  xhr.send(JSON.stringify(params));

  //console.log("xhr repsonse text=" + xhr.responseText);
  const response = JSON.parse(xhr.responseText);
  if (isHttpSuccess(xhr)) {
    console.log(response); // Handle successful creation
    onSuccess(response);
    return true;
  } else {
	onFailure(response);
    return false;
  }
}

function getBookingsFromSelection(selectedCells, target_pid = null) {
    let bookings = []
    selectedCells.forEach(cell => {
      let idparts = cell.id.split('-');
      let when = idparts[idparts.length - 1] 
      let uid  = idparts[idparts.length - 2]
      let pid  = target_pid === null ? idparts[idparts.length - 3] : target_pid;
      let targetDate = getDateNDaysFromNow(startdate, parseInt(when));
      let day   = targetDate.getDate().toString();
      let month = (targetDate.getMonth() + 1).toString();
      let year  = targetDate.getFullYear().toString();
      let booking = {"when(3i)": day, "when(2i)": month, "when(1i)": year, user_id: uid, project_id: pid};
      console.log("booking:" + JSON.stringify(booking));
      bookings.push({booking: booking})
    });
    return bookings;
}  

export function pixel2int(px) {
	return parseInt(px.slice(0, -2))
}

export function box2int(box) {
	return Object.fromEntries(Object.entries(box).map(([key, value]) => [key, pixel2int(value)]));
}

export function sortProjects(projects) {
    return projects.sort((a, b) => a.name.localeCompare(b.name));
}

export function popupProjectsList(projects) {
	return projects.filter(p => p.status !== 1).sort((a, b) => a.name.localeCompare(b.name));
}

export function userFromRow(users, row) {
  console.log("row id=" + row.id);
  let s = row.id.split('-');
  if (s.length < 2) {
	return [null, null]
  }
  let uid = s[1];
  return [users.find(u => u.id.toString() === uid), parseInt(s[0])];
}

/*
export function getResourceRange(b, users, timesheet) {
	let timesheet_rect = timesheet.getBoundingClientRect();
	let starty = b.y + timesheet_rect.y;

	let sel_range = [];
	let selected_pid = null;
	let u = null;
	document.querySelectorAll(".resource-row").forEach(div => {
		const rect = div.getBoundingClientRect();

		  const intersects = (rect.y >= starty) && rect.y < (starty + b.height);

		  if (intersects) {
			[u, selected_pid] = userFromRow(users, div);
			sel_range.push(u);
		  }
	});
	return [sel_range, selected_pid];
}
*/

export function getResourceRange(b, users, timesheet) {
	let sel_range = [];
	let main_pid = null;
	let u = null;
	
	let startRow = b.y / rowHeight;
	let endRow = startRow + b.height / rowHeight;
	console.log("startRow=" + startRow + " endRow=" + endRow)
	let k = 0;
	document.querySelectorAll(".resource-row").forEach(div => {
		console.log("div id=" + div.id)
		const rect = div.getBoundingClientRect();
		let [u, selected_pid] = userFromRow(users, div);
		
		console.log("k=" + k)
		if (k >= startRow && k < endRow && u) {
      if (selected_pid !== null) {
			  main_pid = selected_pid
		  }

			console.log("found resource=" + JSON.stringify(u) + " selected_pid=" + selected_pid)
			sel_range.push(u);
		}
		k++
	});
	console.log("sel_range=" + JSON.stringify(sel_range) + " main_pid=" + main_pid)

	return [sel_range, main_pid];
}


export function setDim(rect, l, t, w, h) {
    rect.style.left = `${l}px`;
	rect.style.top = `${t}px`;
	rect.style.width = `${w}px`;
	rect.style.height = `${h}px`;
	
	console.log("rect.style.left=" + l + " rect.style.top=" + t + " rect.style.width=" + w + " rect.style.height=" + h);
}

export function getProjectBookings(bookings, p) {
	console.log("p=" + JSON.stringify(p))
	return (p.id === 0) ? bookings : bookings.filter(b => b.project_id === p.id);		
}


export function getUserBookings(pid2pnames, bookings, p, u, isprintView) {
  let bs = bookings.filter(b => isUserBooking(p, u, b)).filter(b => isBookingInProject(p, b) && (isprintView ? p.id === b.project_id : true)).map(b => prepTask(pid2pnames, p, u, b))
  return  Array.from(bs);	
}

export function removeLastn(str, n) {
  console.log("str.substring(0, str.length - 3)=" + str.substring(0, str.length - 3));
  return str.substring(0, str.length - 3);
}

export function getProjectFromRow(e, projects) {
  let row = e.target.closest(".resource-row");
  if (!row || !row.id) {
	return null;
  }
  console.log("getProjectFromRow id=" + row.id)
  let id_split = row.id.split('-');
  if (id_split.length < 2) {
	return null;
  }
  let pid = parseInt(id_split[0]);
  if (isNaN(pid)) {
	return null;
  }
  return projects.find(p => p.id === pid) ?? null;

}

export function formatDateDDMMYYYY(date, sep='-') {
  const day = String(date.getUTCDate()).padStart(2, "0");      // Day with leading zero
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
  const year = date.getFullYear();

  return `${day}${sep}${month}${sep}${year}`;
}

export function formatDateYYYYMMDD(date, sep='-') {
  const day = String(date.getUTCDate()).padStart(2, "0");      // Day with leading zero
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month (0-indexed) with leading zero
  const year = date.getFullYear();

  return `${year}${sep}${month}${sep}${day}`;
}

export function formatDateYYMMDD(date, sep = '-') {
  const day = String(date.getDate()).padStart(2, "0");            // Day (Local)
  const month = String(date.getMonth() + 1).padStart(2, "0");     // Month (0-indexed)
  
  // Get 4-digit year, convert to string, and take last 2 characters
  const year = String(date.getFullYear()).slice(-2);              

  return `${year}${sep}${month}${sep}${day}`;
}

export function germanToISODate(germanDate) {
	return new Date(germanToISO(germanDate));
}

export function germanToISO(germanDate) {
  // Convert "dd.mm.yyyy" → "yyyy-mm-dd"
  const [day, month, year] = germanDate.split("-");
  if (!day || !month || !year) return "";
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}

export function isoToGerman(isoDate) {
  // Convert "yyyy-mm-dd" → "dd.mm.yyyy"
  const [year, month, day] = isoDate.split("-");
  if (!year || !month || !day) return "";
  return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
}

export function getDateUTC(date) {	
  return new Date(formatDateYYYYMMDD(date) + "T00:00:00");
}

export function getXDateUTC(x, xpos) {
	return getDateUTC(x.invert(xpos));
}

export function germanDateToUTC(german) {
	if (german == null) {
		return null;
	}
	return getDateUTC(new Date(germanToISO(german)));
}

export function isoDateToUTC(iso) {
	if (iso == null) {
		return null;
	}
	return getDateUTC(new Date(iso));
}

export function scrollToToday(x) {
  const targetX = x(new Date()) - 100;
  document.getElementById('main-scroll-area').scrollLeft = Math.max(0, targetX);
};

export function applyResoureFilter(resourceFilter, p, u) {
  let rf = resourceFilter;
  return rf.selection === 1 ? rf.individual.includes(u.id) : rf.hasBookings.includes(u.id);
}

export function hasBookings(p, users, bookings) {
  let today = new Date();
  let sixWeeksLater = nDaysLater(today, 42);
  let hb = [];
  for (const u of users) {
    if (bookings.some(b => (b.project_id === p.id && b.user_id === u.id && is_bookable(b, [today , sixWeeksLater])))) {
  	  hb.push(u.id);
    }
  }
  return hb;
}

export function computeResourceFilter(view, projects, users, bookings) {
  
  let resourceFilter = {};
  for (const p of projects) {
    let rf = view.getResourceFilter(p.id);
	resourceFilter[p.id] = {selection: rf.selection, individual: rf.individual, hasBookings: hasBookings(p, users, bookings)};
  }
  //console.log("hasBookings=" + JSON.stringify(hasBookings))
  return resourceFilter;
}

export function removeSelections() {
  document.querySelectorAll(".editable").forEach(t => t.classList.remove("editable"));
  document.querySelectorAll(".highlight-bar").forEach(t => t.classList.remove("highlight-bar"));
}

export async function generateTiledPdf(
  project,
  timesheetEl,
  cornerEl,
  sidebarEl,
  html2canvas,
  jsPDF,
  onProgress
) {
  const pdf = new jsPDF("l", "mm", "a4");

  // --- MARGINS ---
  const marginL = 10;
  const marginR = 10;
  const marginT = 20;
  const marginB = 10;

  const pageWidthMm = pdf.internal.pageSize.getWidth();
  const pageHeightMm = pdf.internal.pageSize.getHeight();

  const pxToMm = (px) => (px * 25.4) / 96;
  const mmToPx = (mm) => (mm * 96) / 25.4;

  const scaleFactor = 2;

  const sidebarWidthMm = pxToMm(sidebarEl.offsetWidth);
  const cornerHeightMm = pxToMm(cornerEl.offsetHeight);

  // --- 1. PRE-RENDER THE LOGO (SMALLER SCALE) ---
  const cornerCanvas = document.createElement('canvas');
  const ctx = cornerCanvas.getContext('2d');
  const logoImg = cornerEl.querySelector('img');

  const scale = scaleFactor;
  cornerCanvas.width = cornerEl.offsetWidth * scale;
  cornerCanvas.height = cornerEl.offsetHeight * scale;

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, cornerCanvas.width, cornerCanvas.height);

  if (logoImg && logoImg.complete) {
      const aspectRatio = logoImg.naturalWidth / logoImg.naturalHeight;
      
      // SCALE: Reduced to 35% of container width
      const destWidth = (cornerEl.offsetWidth * 0.35) * scale; 
      const destHeight = destWidth / aspectRatio;
      
      // POSITIONING: 8px padding for a cleaner look
      const padding = 8 * scale;
      
      // Optional: High-quality scaling
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      ctx.drawImage(logoImg, padding, padding, destWidth, destHeight);
  }

  const cornerImg = cornerCanvas.toDataURL("image/jpeg", 0.95);

  // --- TRUE dimensions (NO -1 hacks) ---
  const totalWidth = timesheetEl.scrollWidth;
  const totalHeight =
    cornerEl.scrollHeight + sidebarEl.scrollHeight;

  // --- USABLE GRID WIDTH ---
  const usableGridWidthMm =
    pageWidthMm - marginL - marginR - sidebarWidthMm;

  const rawPxGridPageWidth = mmToPx(usableGridWidthMm);

  // Snap to full day width (ALL IN PX)
  const widthPerDayPx = getWidthPerDay(true);

  const pxGridPageWidth =
    Math.floor(rawPxGridPageWidth / widthPerDayPx) *
    widthPerDayPx;

  // --- USABLE HEIGHT ---
  const usableHeightMm = pageHeightMm - marginT - marginB;
  const pxPageHeight = Math.floor(mmToPx(usableHeightMm));

  const cols = Math.ceil(totalWidth / pxGridPageWidth);
  const rows = Math.ceil(totalHeight / pxPageHeight);
  const totalSteps = cols * rows;

  let currentStep = 0;

  for (let y = 0; y < totalHeight; y += pxPageHeight) {
    const remainingHeight = totalHeight - y;
    const capturedPxHeight = Math.min(
      pxPageHeight,
      remainingHeight
    );

    if (capturedPxHeight <= 1) continue;

    const sliceHeightMm = pxToMm(capturedPxHeight);

    // --- SIDEBAR SLICE ---
    const sidebarSliceCanvas = await html2canvas(
      sidebarEl,
      {
        scale: scaleFactor,
        useCORS: true,
        width: sidebarEl.offsetWidth,
        height: capturedPxHeight,
        y: y,
        scrollY: -y,
        windowHeight: sidebarEl.scrollHeight
      }
    );

    const sidebarSliceImg =
      sidebarSliceCanvas.toDataURL("image/jpeg", 0.95);

    for (let x = 0; x < totalWidth; x += pxGridPageWidth) {
      const remainingWidth = totalWidth - x;
      const capturedPxWidth = Math.min(pxGridPageWidth, remainingWidth);
      if (capturedPxWidth <= 1) continue;

      // --- DIRECT CAPTURE METHOD (Faster & More Reliable) ---
      const canvas = await html2canvas(timesheetEl, {
          scale: scaleFactor,
          useCORS: true,
          width: capturedPxWidth,
          height: capturedPxHeight,
          x: x,        // This tells html2canvas where to start the "photo" horizontally
          y: y,        // This tells it where to start vertically
          scrollX: -x, // Important: syncs the coordinate system
          scrollY: -y,
          // windowWidth/Height ensures the renderer doesn't clip to the visible screen
          windowWidth: totalWidth,
          windowHeight: totalHeight
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.85);

      if (currentStep > 0) pdf.addPage();
      currentStep++;

      // --- DRAW CORNER ---
      pdf.addImage(cornerImg, "JPEG", marginL, marginT, sidebarWidthMm, cornerHeightMm);

      // --- DRAW SIDEBAR ---
      pdf.addImage(sidebarSliceImg, "JPEG", marginL, marginT + cornerHeightMm, sidebarWidthMm, sliceHeightMm);

      pdf.addImage(imgData, "JPEG", marginL + sidebarWidthMm, marginT, pxToMm(capturedPxWidth), sliceHeightMm);

      // --- HEADER TEXT ---
      pdf.setFontSize(10);
      pdf.setTextColor(100);

      let title = project.name + " " + project.description
      pdf.setFont("helvetica", "bold");
      pdf.text(title, marginL + sidebarWidthMm + 5, marginT - 5);

      pdf.setFont("helvetica", "normal");
      pdf.text("Personalplan Ausgabedatum ", marginL + sidebarWidthMm + 5, marginT + 2);

      pdf.setFont("helvetica", "bold");
      pdf.text(formatDateDDMMYYYY(new Date(), "."), marginL + sidebarWidthMm + 51, marginT + 2);

      // --- PAGE NUMBER ---
      const pageText = `${currentStep} / ${totalSteps}`;
      const textWidth =
        (pdf.getStringUnitWidth(pageText) *
          pdf.getFontSize()) /
        pdf.internal.scaleFactor;

      pdf.text(
        pageText,
        pageWidthMm - marginR - textWidth,
        pageHeightMm - marginB / 2
      );

      if (onProgress) {
        onProgress((currentStep / totalSteps) * 100);
      }
    }
  }

  const fileName = project.name + " Personalplan TI " + formatDateYYMMDD(new Date(), "");

  pdf.save(`${fileName}.pdf`);
}
